import { render, staticRenderFns } from "./InsuredEntity.vue?vue&type=template&id=352ccea6"
import script from "./InsuredEntity.vue?vue&type=script&lang=js"
export * from "./InsuredEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports